import { IAuthInfoModel, IAuthUserDevice, IAuthUserToken, IStaffLoginInfo } from "../model";
import { OrganizationTypeEnum } from "../enums";

export const staffLoginInfoInitial:IStaffLoginInfo = {
  id: 0,
  email: "",
  name: "",
  organizationId: 0,
  lastName: "",
  schoolIds: [],
  authorizationIds: [],
  classroomIds: [],
  position: 2,
  organizationTypeId: OrganizationTypeEnum.B2bCustomer
}

export const authUserDeviceInitial : IAuthUserDevice = {
  deviceUUID:''
}
export const authUserTokenInitial:IAuthUserToken = {
  refreshToken:'',
  token:''
}

export const authInfoInitial: IAuthInfoModel = {
  authentication:authUserTokenInitial,
  device:authUserDeviceInitial,
  roleId:0,
  staffInfo:staffLoginInfoInitial,
}
